export const getHeatMapItemBgColor = (mastered: number): string => {
  switch (mastered) {
    case 0:
      return '#FFF';
    case 1:
      return '#EAF0FE';
    case 2:
      return '#C1D2FC';
    case 3:
      return '#83A5FA';
    case 4:
      return '#3169F6';
    default:
      return '#0414A2';
  }
};

export const getHeatMapItemBorderColor = (
  mastered: number,
  isToday: boolean,
  bgColor: string
): string => {
  if (isToday) {
    return '#EA0BBD';
  }

  if (mastered <= 0) {
    return '#83A5FA';
  }

  return bgColor;
};

export const GRID_ITEM_ANIMATION_DURATION = 1.25;
export const GRID_ITEM_ICON_ANIMATION_DELAY = GRID_ITEM_ANIMATION_DURATION * 6;

export const getAnimationDelay = (mastered: number | undefined | null): number => {
  if (!mastered || mastered <= 0) {
    return 0.25;
  }

  if (mastered < 5) {
    return GRID_ITEM_ANIMATION_DURATION * mastered;
  }

  return GRID_ITEM_ANIMATION_DURATION * 5;
};
